import { Nullable } from 'modules/types/common';
import { createReducer } from '@reduxjs/toolkit';
import { MessageAttachment } from '../types';
import {
  DOWNLOAD_MESSAGE_ATTACHMENT,
  DOWNLOAD_MESSAGE_ATTACHMENT_FAIL,
  DOWNLOAD_MESSAGE_ATTACHMENT_SUCCESS
} from '../actions';

interface DownloadObject {
  mediaIdentifier: MessageAttachment['mediaIdentifier'];
  isDownloading: boolean;
  error: Nullable<Error>;
}

export type MessageDownloadState = Record<string, DownloadObject>;

export const messageDownloadReducer = createReducer<MessageDownloadState>(
  {},
  {
    [DOWNLOAD_MESSAGE_ATTACHMENT]: (state, action) => {
      state[action.payload.attachment.mediaIdentifier] = {
        mediaIdentifier: action.payload.attachment.mediaIdentifier,
        isDownloading: true,
        error: null
      };
    },

    [DOWNLOAD_MESSAGE_ATTACHMENT_SUCCESS]: (state, action) => {
      state[action.payload.attachment.mediaIdentifier] = {
        mediaIdentifier: action.payload.attachment.mediaIdentifier,
        isDownloading: false,
        error: null
      };
    },

    [DOWNLOAD_MESSAGE_ATTACHMENT_FAIL]: (state, action) => {
      state[action.payload.attachment.mediaIdentifier] = {
        mediaIdentifier: action.payload.attachment.mediaIdentifier,
        isDownloading: false,
        error: action.error
      };
    }
  }
);

export default messageDownloadReducer;
